import React, { useEffect, useState, useRef } from "react";
import { HomeWrapper } from "../components/utils/HomeWrapper";
import { Button, Link } from "@mui/material";
import { HubSectionDialog } from "../components/dialog/HubSectionDialog";
import useMediaQuery from "@mui/material/useMediaQuery";
import device from "current-device";
import { HubCard } from "../components/hub/HubCard";
import { pHelpURLs } from "../utils/parameters";
import CircularProgress from '@mui/material/CircularProgress';
import MonitorHeartIcon from '@mui/icons-material/MonitorHeart';
import { pDB_user_roles } from '../utils/parameters.js';
import { useDataProvider } from '../api/DataProvider';
import { useCommProvider } from "../api/CommProvider";
import { WebInfoDialog } from "../components/dialog/WebInfoDialog";
import { HubDiccionaries, HubGames } from "../components/hub/HubItems.js";
import { useHistory } from "react-router-dom";
import { useLocation } from 'react-router-dom';
import { pLoginTab } from "../utils/parameters";
import "../styles/devices/mob_Hub.css";
import { useTranslation } from "react-i18next";
import { DeviceQueries } from "../components/utils/DeviceQueries.js";

export function Hub() {
    const [activeCard, setActiveCard] = useState(0);
    const [openHubSectionDialog, setOpenHubSectionDialog] = useState(false);
    const [openWebInfoDialogFromHub, setOpenWebInfoDialogFromHub] = useState(false);
    const titleRef = useRef("");
    const textRef = useRef("");
    const videoRef = useRef(null);
    const videoTutorialRef = useRef(null);
    const linkRef = useRef("");
    const [userLoaded, setUserLoaded] = useState(false);
    const { currentUserRole, setCurrentUser } = useDataProvider();
    const { comm_logout } = useCommProvider();
    const { t } = useTranslation("global")
    
    /* MOB - Nav responsiveness*/
    const queryMatches = DeviceQueries();

    // MOB - Make menu visible when user role is updated
    useEffect(() => {
        if (currentUserRole !== pDB_user_roles.none){
            setUserLoaded(true);
        }
    },[currentUserRole]);

    // useEffect(() => {
    //     // Verificar si los scripts ya están cargados
    //     if (window.botpressWebChat) {
    //       return;
    //     }
      
    //     // Crear el elemento script para el inject.js
    //     const scriptInject = document.createElement('script');
    //     scriptInject.src = 'https://cdn.botpress.cloud/webchat/v1/inject.js';
    //     scriptInject.async = true;
      
    //     // Crear el elemento script para el config.js
    //     const scriptConfig = document.createElement('script');
    //     scriptConfig.src = 'https://mediafiles.botpress.cloud/0caac1c1-2007-4120-a2f3-856b5a99b500/webchat/config.js';
    //     scriptConfig.defer = true;
      
    //     // Añadir los scripts al DOM
    //     document.body.appendChild(scriptInject);
    //     document.body.appendChild(scriptConfig);
      
    //     // Inicializar Botpress webchat después de que los scripts se hayan cargado
    //     scriptConfig.onload = () => {
    //       if (window.botpressWebChat) {
    //         window.botpressWebChat.init({
    //           // Tu configuración de Botpress webchat aquí
    //         });
    //       }
    //     };
      
    //     // Limpiar los scripts cuando el componente se desmonte
    //     return () => {
    //       document.body.removeChild(scriptInject);
    //       document.body.removeChild(scriptConfig);
    //     };
    //   }, []);

    function ShowInfoDialog(title, text, video, videoTutorial, link) {
        titleRef.current = title;
        textRef.current = text;
        videoRef.current = video;
        videoTutorialRef.current = videoTutorial;
        linkRef.current = link;
        setOpenHubSectionDialog(true);
    }

    function handleActiveCard(card) {
        if (!queryMatches.desktop) {
            setActiveCard(card);
        }
    }
    
    function handleDeactiveCard() {
        setActiveCard(0);
    }

    function handleOpenWebInfoDialogFromHub() {
        setOpenWebInfoDialogFromHub(true);
    }

    const handleClickOpenURL = (url) => () => {
        window.open(url, "_blank", "noopener,noreferrer");
    };

    const history = useHistory();
    const handleRegistrationSection = () => {
        // console.log('handleRegistrationSection')
        comm_logout();
        history.push({
            pathname: "/sign",
            loginTab: pLoginTab.register,
        });
        setCurrentUser(null);
    };

    const location = useLocation();
    useEffect(() => {
        if (location.state && location.state.prev) {
            // Aquí puedes decidir si redirigir o no según la URL previa
            // Por ejemplo, si quieres redirigir automáticamente a la URL previa:
            if (location.state.prev == '/survey'){
                history.push(location.state.prev);
            }else{
                history.push("/");
            }
        }
    }, [location, history]);
    


    return (
        <HomeWrapper>
            <div onClick={handleDeactiveCard} className="sig_Hub_Root">

            <div className='sig_Hub_InfoTitle'>{t("sHub.section_info_proyect_title").toUpperCase()}</div>
                <div className='sig_Hub_InfoSubTitle'>{t("sHub.section_info_proyect_body")}</div>
                <Button className="sig_Hub_Card_ButtonModal sig_Hub_ButtonBig" onClick={handleClickOpenURL(pHelpURLs.main)}>
                {t("sHub.section_info_proyect_web").toUpperCase()}
                </Button>

                <div className='sig_Hub_InfoTitle'> {t("sHub.section_main_title").toUpperCase()}</div>

                {!userLoaded &&
                    <div className={`sig_Hub_InfoSubTitle ${userLoaded ? '' : 'sig_Hub_InfoSubTitleLoading'}`}>
                        {userLoaded ? t("sHub.loadedSubtitle") : t("sHub.loadingSubtitle")}
                    </div>
                }

                
                <div className="sig_Hub_MainContainer">
                    
                    { userLoaded ? 
                    <>
                        {/* <div className='sig_Hub_InfoCategories'>{t("sHub.section_diccionary_title").toUpperCase()}</div> */}
                        {HubDiccionaries.map(item => {
                                const { cardID, cardImg, cardTitle, cardText, cardVideo, cardVideoTutorial, cardLink, roles } = item;
                                return (
                                    ( roles.includes(currentUserRole) ) ?( 
                                        <div key={cardID} className="sig_Hub_CardContainer">
                                            <HubCard 
                                                activeCard={activeCard}
                                                cardID={cardID}
                                                cardImg={cardImg} 
                                                cardTitle={t(cardTitle)}
                                                cardText={t(cardText)}
                                                cardVideo={cardVideo} 
                                                cardVideoTutorial={cardVideoTutorial} 
                                                cardLink={cardLink}
                                                desktop={queryMatches.desktop} 
                                                handleActiveCard={handleActiveCard} 
                                                handleDeactiveCard={handleDeactiveCard} 
                                                ShowInfoDialog={ShowInfoDialog}
                                            />
                                        </div>
                                    )
                                    : <></>
                                )
                                })
                        }
                        <div className='sig_Hub_InfoCategories'> {t("sHub.section_studies_games_title").toUpperCase()} </div>
                        {currentUserRole==pDB_user_roles.invitated && 
                            <div className='sig_Hub_InfoSubTitle'>
                                    <>
                                    {t("sHub.loadedSubtitleInvited")}
                                    <br></br>
                                    <span><Link underline="hover" target="_blank" onClick={handleRegistrationSection} style={{ cursor: 'pointer'}}><strong>{t("sHub.loadedSubtitleInvited2").slice(0, t("sHub.loadedSubtitleInvited2").indexOf(" "))}</strong> {t("sHub.loadedSubtitleInvited2").slice(t("sHub.loadedSubtitleInvited2").indexOf(" "))}</Link></span>
                                    <br></br>
                                    </>
                            
                            </div>
                        }
                        
                        {HubGames.map(item => {
                                const { cardID, cardImg, cardTitle, cardText, cardVideo, cardVideoTutorial, cardLink, roles } = item;
                                return (
                                    ( roles.includes(currentUserRole) ) ?(
                                        <div key={cardID} className="sig_Hub_CardContainer">
                                            <HubCard 
                                                activeCard={activeCard}
                                                cardID={cardID}
                                                cardImg={cardImg} 
                                                cardTitle={t(cardTitle)}
                                                cardText={t(cardText)}
                                                cardVideo={cardVideo} 
                                                cardVideoTutorial = {cardVideoTutorial}
                                                cardLink={cardLink}
                                                desktop={queryMatches.desktop} 
                                                handleActiveCard={handleActiveCard} 
                                                handleDeactiveCard={handleDeactiveCard} 
                                                ShowInfoDialog={ShowInfoDialog}
                                            />
                                        </div>
                                    )
                                    : <></>
                                )
                                })
                        }
                    </>
                    : 
                    <div className='sig_Hub_LoadingContainer'  onClick={handleOpenWebInfoDialogFromHub} >
                        <div className='sig_Hub_LoadingButton'>
                            <div className='sig_Hub_LoadingButtonIcon sig_Home_ChangeOnDarkMode'> 
                                <MonitorHeartIcon /> 
                            </div>
                        </div>
                        <CircularProgress variant='indeterminate' className='sig_Hub_LoadingCircle' size={100} thickness={2} />
                    </div>
                    }
                </div>
                
            </div>
            <HubSectionDialog 
                openHubSectionDialog={openHubSectionDialog} 
                setOpenHubSectionDialog={setOpenHubSectionDialog} 
                titleRef={titleRef.current} 
                textRef={textRef.current} 
                videoRef={videoRef.current} 
                videoTutorialRef={videoTutorialRef.current}
                linkRef={linkRef.current} />
            <WebInfoDialog 
                openDialog={openWebInfoDialogFromHub} 
                setOpenDialog={setOpenWebInfoDialogFromHub}/>
        </HomeWrapper>    
    );
}